module.exports = __webpack_public_path__ + "img/Hybrid Cloud.71fb42b.svg";